
import ErrorBox from 'parts/ErrorBox';

const CustomError = () => (
  <ErrorBox />
);

export default CustomError;
